// const Hero = () => {
//   return (
//     <header id="home" className="hero">
//       {/* <i class="fas fa-laptop-code hero-icon"></i> */}
//       <i className="fas fa-user-astronaut hero-icon"></i>
//       <h1>Hello, I'm Abdullahi</h1>
//       <h2>Junior Frontend Developer</h2>
//       <p>
//         Building beautiful, responsive, and interactive web experiences in React
//         & JavaScript.
//       </p>
//       <a href="#contact" className="btn">
//         <i className="fas fa-briefcase" style={{ marginRight: "8px" }}></i>
//         Hire Me
//       </a>
//     </header>
//   );
// };

// export default Hero;

import { useState, useEffect } from "react";

const Hero = () => {
  const [isImageOpen, setIsImageOpen] = useState(false);

  const openImage = () => setIsImageOpen(true);
  const closeImage = () => setIsImageOpen(false);

  const handleImageKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      openImage();
    }
  };

  useEffect(() => {
    if (!isImageOpen) return;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        closeImage();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isImageOpen]);

  return (
    <header id="home" className="hero">
      {/* <i className="fas fa-user-astronaut hero-icon"></i> */}
      <img
        src="/file.jpg"
        alt="Abdullahi"
        className="profile-pic"
        onClick={openImage}
        onKeyDown={handleImageKeyDown}
        role="button"
        tabIndex={0}
        title="Click to enlarge profile picture"
        aria-label="Open larger profile picture"
      />
      <h1>Hello, I'm Abdullahi</h1>
      <h2>Junior Full-Stack Developer (AI Focus)</h2>
      <p>
        I build modern, responsive full‑stack applications with React, Node.js,
        and TypeScript, while growing strong skills in Python, machine learning,
        and AI.
      </p>

      <div className="hero-buttons">
        <a href="#contact" className="btn">
          <i className="fas fa-briefcase" style={{ marginRight: "8px" }}></i>
          Hire Me
        </a>

        <a
          href="https://github.com/Abdullahi23-H"
          target="_blank"
          rel="noopener noreferrer"
          className="btn"
        >
          <i className="fab fa-github" style={{ marginRight: "8px" }}></i>
          GitHub
        </a>

        <a
          href="https://www.linkedin.com/in/abdullhi-kediye-a05552373"
          target="_blank"
          rel="noopener noreferrer"
          className="btn"
        >
          <i className="fab fa-linkedin" style={{ marginRight: "8px" }}></i>
          LinkedIn
        </a>
      </div>

      <div className="hero-scene" aria-hidden="true">
        <img
          src="/developer-at-desk-illustration.png"
          alt="Developer at desk with laptop showing code, coffee, and notebook"
          className="hero-illustration"
        />
      </div>

      {isImageOpen && (
        <div className="image-modal-backdrop" onClick={closeImage}>
          <div
            className="image-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="image-modal-close" onClick={closeImage}>
              &times;
            </button>
            <img src="/file.jpg" alt="Abdullahi large" />
          </div>
        </div>
      )}
    </header>
  );
};

export default Hero;
